export default __webpack_public_path__ + "static/media/TGcopy.c239fec7.png";